import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import LocalizationWrapper from './LocalizationWrapper';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import Login from './Login';
import Main from './Main';
import theme from './theme';
import { useJsApiLoader } from "@react-google-maps/api";

// Google Maps APIキー
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// 認証API URL
export const authURL = process.env.REACT_APP_AUTH_API_BASE_URL;
// ユーザAPI URL
export const userURL = process.env.REACT_APP_USER_API_BASE_URL;
// Fast API URL
export const apiURL = process.env.REACT_APP_FAST_API_BASE_URL;
// ストレージ URL
export const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

// 認証付きルート用ラッパ
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  // アクセストークンがなければログインへリダイレクト
  const token = localStorage.getItem('accesstoken');
  if (!token || token === 'undefined') {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// メインコンポーネント
const App = () => {
  // Google Maps APIの読み込み状態
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY!,
    libraries: ["places"],
    language: "ja",
    region: "JP"
  });
  
  // Google Maps APIが読み込まれていない場合は何も描画しない（null返却）
  if (!isLoaded) return null;

  // レンダリング
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationWrapper>
        <div className="App">
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/" element={<ProtectedRoute><Main mode="Home" /></ProtectedRoute>} />
              <Route path="/details/:id" element={<ProtectedRoute><Main mode="EditDetails" /></ProtectedRoute>} />
              <Route path="/new" element={<ProtectedRoute><Main mode="New" /></ProtectedRoute>} />
              <Route path="/new/details/:id" element={<ProtectedRoute><Main mode="NewDetails" /></ProtectedRoute>} />
              <Route path="/entry" element={<ProtectedRoute><Main mode="Entry" /></ProtectedRoute>} />
              <Route path="/entry/details/:id" element={<ProtectedRoute><Main mode="EditDetails" /></ProtectedRoute>} />
              <Route path="/broadcast" element={<ProtectedRoute><Main mode="Broadcast" /></ProtectedRoute>} />
              <Route path="/search" element={<ProtectedRoute><Main mode="Search" /></ProtectedRoute>} />
              <Route path="/search/details/:id" element={<ProtectedRoute><Main mode="EditDetails" /></ProtectedRoute>} />
              <Route path="/search/view/map" element={<ProtectedRoute><Main mode="Map" /></ProtectedRoute>} />
              <Route path="/search/view/calender" element={<ProtectedRoute><Main mode="Calender" /></ProtectedRoute>} />
              <Route path="/memo/search" element={<ProtectedRoute><Main mode="MemoSearch" /></ProtectedRoute>} />
              <Route path="/memo/search/new" element={<ProtectedRoute><Main mode="MemoNew" /></ProtectedRoute>} />
              <Route path="/memo/search/details/:id" element={<ProtectedRoute><Main mode="MemoEdit" /></ProtectedRoute>} />
              <Route path="/memo/search/view/map" element={<ProtectedRoute><Main mode="MemoMap" /></ProtectedRoute>} />
              <Route path="/view/calender" element={<ProtectedRoute><Main mode="Calender" /></ProtectedRoute>} />
              <Route path="/manage" element={<ProtectedRoute><Main mode="Admin" /></ProtectedRoute>} />
              <Route path="/login" element={<Login />} />
              <Route element={<p>not found!!!</p>} />
            </Routes>
          </BrowserRouter>
        </div>
      </LocalizationWrapper>
    </ThemeProvider>
  );
}

export default App;
